import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import Header from './Header'
import AdminHeader from './AdminHeader'
import Footer from './Footer'
import MobileSidebar from './MobileSidebar'
import { motion } from 'framer-motion'

/**
 * Layout - Main layout wrapper component
 * 
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Page content to render
 * 
 * @example
 * <Layout>
 *   <HomePage />
 * </Layout>
 */
const Layout = ({ children }) => {
  const location = useLocation()
  const isAdminRoute = location.pathname.startsWith('/admin')
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {isAdminRoute ? <AdminHeader /> : <Header />}
      
      <motion.main
        className="flex-1"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.main>
      
      {!isAdminRoute && <Footer />}
      
      {/* Mobile Sidebar */}
      {!isAdminRoute && <MobileSidebar />}
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
